import { Box } from "@mui/material";
import CountUp from "../motion/CountUp";

// design at 472px wide; u() converts to container-relative units so screens scale with the phone
const u = (n) => `${(n / 4.72).toFixed(3)}cqw`;
const PURPLE = "#8B5CF6";
const RED = "#C40000";
const GREEN = "#4C9A00";

const Bar = ({ title }) => (
  <Box sx={{ bgcolor: PURPLE, color: "#fff", height: u(112), pt: u(48), px: u(24), fontSize: u(26), fontWeight: 500, boxSizing: "border-box" }}>
    <Box sx={{ mt: u(16) }}>{title}</Box>
  </Box>
);

const Card = ({ icon, bg, amt, remark, date }) => (
  <Box sx={{ bgcolor: "#fff", borderRadius: u(14), boxShadow: "0 2px 6px rgba(0,0,0,0.18)", p: u(14), mx: u(16), mb: u(12), display: "flex", gap: u(14), alignItems: "center" }}>
    <Box sx={{ width: u(52), height: u(52), borderRadius: "50%", bgcolor: bg, display: "grid", placeItems: "center", fontSize: u(26), flexShrink: 0 }}>{icon}</Box>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", fontSize: u(24), fontWeight: 600 }}>
        <span>{amt}</span>
        <span style={{ fontSize: u(15), color: "#999", fontWeight: 400 }}>{date} <span style={{ color: RED }}>↓</span></span>
      </Box>
      <Box sx={{ fontSize: u(17), color: "#222", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{remark}</Box>
    </Box>
  </Box>
);

const TX = [
  ["🥦", "#f5f5f5", "₹247", "Groceries", "19 Aug"],
  ["🍽️", "#d5f5ee", "₹185", "Green tea", "19 Aug"],
  ["📄", "#dbe7ff", "₹1,000", "Registry fees", "18 Aug"],
  ["⛽", "#dbe7ff", "₹2,000", "Fuel", "18 Aug"],
  ["💊", "#f5f5f5", "₹10", "Medicine", "18 Aug"],
];

export const Dashboard = ({ active }) => (
  <Box sx={{ height: "100%", bgcolor: "#fafafa" }}>
    <Box sx={{ bgcolor: PURPLE, color: "#fff", height: u(190), pt: u(48), px: u(20), boxSizing: "border-box" }}>
      <Box sx={{ fontSize: u(17), mt: u(14), opacity: 0.9 }}>Good afternoon</Box>
      <Box sx={{ fontSize: u(26), fontWeight: 600 }}>Alex Morgan</Box>
    </Box>
    <Box sx={{ textAlign: "center", fontSize: u(22), py: u(14) }}>Current Month · August</Box>
    <Box sx={{ display: "flex", gap: u(12), px: u(12) }}>
      <Box sx={{ flex: 1, bgcolor: RED, color: "#fff", borderRadius: u(30), p: `${u(10)} ${u(18)}` }}>
        <Box sx={{ fontSize: u(13), opacity: 0.85 }}>Expense</Box>
        <Box sx={{ fontSize: u(22), fontWeight: 600 }}><CountUp to={169261} run={active} /></Box>
      </Box>
      <Box sx={{ flex: 1, bgcolor: GREEN, color: "#fff", borderRadius: u(30), p: `${u(10)} ${u(18)}` }}>
        <Box sx={{ fontSize: u(13), opacity: 0.85 }}>Income</Box>
        <Box sx={{ fontSize: u(22), fontWeight: 600 }}><CountUp to={195000} run={active} /></Box>
      </Box>
    </Box>
    <Box sx={{ width: "fit-content", mx: "auto", my: u(12), bgcolor: "#eee", borderRadius: u(6), px: u(18), py: u(4), fontSize: u(17) }}>
      Balance: <CountUp to={25739} run={active} />
    </Box>
    {TX.slice(0, 3).map((t) => <Card key={t[3]} icon={t[0]} bg={t[1]} amt={t[2]} remark={t[3]} date={t[4]} />)}
  </Box>
);

export const AddTransaction = ({ active }) => (
  <Box sx={{ height: "100%", bgcolor: "#fff" }}>
    <Bar title="← Add New Transaction" />
    <Box sx={{ display: "flex", gap: u(14), p: u(16) }}>
      <Box sx={{ flex: 1, bgcolor: RED, color: "#fff", borderRadius: u(30), py: u(12), textAlign: "center", fontSize: u(22), fontWeight: 500 }}>↓ Expense</Box>
      <Box sx={{ flex: 1, bgcolor: "#eee", color: "#aaa", borderRadius: u(30), py: u(12), textAlign: "center", fontSize: u(22) }}>↑ Income</Box>
    </Box>
    {[["Enter amount", "₹185"], ["Enter remark", "Green tea"]].map(([ph, val]) => (
      <Box key={ph} sx={{ mx: u(16), mb: u(18), border: "1px solid #999", borderRadius: u(6), p: `${u(18)} ${u(20)}`, fontSize: u(22), color: active ? "#111" : "#888", transition: "color .4s .6s" }}>
        {active ? val : ph}
      </Box>
    ))}
    <Box sx={{ mx: u(16), bgcolor: "#f5f5f5", borderRadius: u(6), p: u(14), display: "flex", gap: u(14), alignItems: "center" }}>
      <Box sx={{ width: u(34), height: u(34), borderRadius: "50%", bgcolor: "#20c9b0", display: "grid", placeItems: "center", fontSize: u(18) }}>🍽️</Box>
      <Box><Box sx={{ fontSize: u(14), color: "#888" }}>Select Category</Box><Box sx={{ fontSize: u(20), fontWeight: 600 }}>Food &amp; Dining ⌄</Box></Box>
    </Box>
    <Box sx={{ width: "fit-content", mx: "auto", mt: u(18), bgcolor: PURPLE, color: "#fff", borderRadius: u(8), px: u(46), py: u(14), fontSize: u(22), fontWeight: 500, boxShadow: "0 3px 8px rgba(0,0,0,0.25)" }}>💾 Save</Box>
  </Box>
);

export const Transactions = () => (
  <Box sx={{ height: "100%", bgcolor: "#fafafa", overflow: "hidden" }}>
    <Bar title="← Transactions" />
    <Box sx={{ color: PURPLE, fontSize: u(20), px: u(24), py: u(14) }}>August 2026</Box>
    {TX.map((t) => <Card key={t[3]} icon={t[0]} bg={t[1]} amt={t[2]} remark={t[3]} date={t[4]} />)}
  </Box>
);

export const Reports = ({ active }) => (
  <Box sx={{ height: "100%", bgcolor: "#fafafa" }}>
    <Bar title="← Reports" />
    <Box sx={{ display: "flex", m: u(12), borderRadius: u(10), overflow: "hidden", border: "1px solid #eee", fontSize: u(20), textAlign: "center" }}>
      <Box sx={{ flex: 1, bgcolor: PURPLE, color: "#fff", py: u(12) }}>Year</Box>
      <Box sx={{ flex: 1, bgcolor: "#fff", py: u(12) }}>Month</Box>
    </Box>
    <Box sx={{ display: "flex", gap: u(10), px: u(12) }}>
      {[["Income", "₹4,35,000", GREEN], ["Expense", "₹3,07,059", RED], ["Net", "₹1,27,941", GREEN]].map(([l, v, c]) => (
        <Box key={l} sx={{ flex: 1, bgcolor: "#fff", borderRadius: u(10), boxShadow: "0 1px 4px rgba(0,0,0,0.12)", py: u(10), textAlign: "center" }}>
          <Box sx={{ fontSize: u(14), color: "#666" }}>{l}</Box>
          <Box sx={{ fontSize: u(15), fontWeight: 600, color: c }}>{v}</Box>
        </Box>
      ))}
    </Box>
    <Box sx={{ bgcolor: "#fff", borderRadius: u(14), boxShadow: "0 1px 4px rgba(0,0,0,0.12)", m: u(12), p: u(16), textAlign: "center" }}>
      <Box sx={{ textAlign: "left", fontSize: u(20), fontWeight: 600, mb: u(14) }}>Income by category</Box>
      <Box component="svg" viewBox="0 0 120 120" sx={{ width: u(210), height: u(210) }}>
        <circle cx="60" cy="60" r="40" fill="none" stroke="#8B7BF0" strokeWidth="22" />
        <circle
          cx="60" cy="60" r="40" fill="none" stroke="#5B8FEA" strokeWidth="22"
          strokeDasharray="138 252" transform="rotate(-90 60 60)"
          style={{ strokeDashoffset: active ? 0 : 138, transition: "stroke-dashoffset 1.2s cubic-bezier(.22,1,.36,1)" }}
        />
      </Box>
      <Box sx={{ fontSize: u(16), fontWeight: 600 }}>Total ₹4,35,000</Box>
    </Box>
  </Box>
);

export const SCREENS = { home: Dashboard, add: AddTransaction, transactions: Transactions, reports: Reports };
